export const selectCveFieldsState = (state) => state.cveFields;

export const selectCveFields = (state) => selectCveFieldsState(state).cveFields;
export const selectCveFieldsIsFetching = (state) =>
  selectCveFieldsState(state).isFetching;
export const selectCveFieldsError = (state) =>
  selectCveFieldsState(state).error;
